import * as React from 'react';
import {
  action,
  computed,
} from 'mobx';
import { MdReceipt, MdReorder } from 'react-icons/md';
import {
  GridLayoutHeader,
  PageProps,
  PageToolEvents,
  RetrieveFocusType,
} from '../../../../constants';
import {
  NonDrivingDayModel,
  NonDrivingMonthModel,
} from './models';
import { TabModel } from '../../../../models/component';
import { NonDrivingTemplate } from './NonDriving.template';
import { GridLayout } from '../../../../components/layout/GridLayout';
import { InfinityRetrieve } from '../../../../models/common';
import {
  TabHeaderDay,
} from './tabs';
import { ConfirmWarning } from '../../../../utils/confirm';
import { GridLayoutAdditionalHeader } from '../../../../components';
import { PageComponent } from '../../../../utils';

export enum NonDrivingTabId {
  Day,
  Act,
}

export const NonDrivingTabTitles = [
  '일자별',
  '월별통계',
];

export const NonDrivingTabModels = [
  NonDrivingDayModel,
  NonDrivingMonthModel,
];

export const NonDrivingTabFunctionNames = [
  'tab_1',
  'tab_2',
];

export const NonDrivingTabDataStateNames = [
  'dayList',
  'monthlist',
];

export interface NonDrivingState {
  dayList?: Array<NonDrivingDayModel>; // 부품내역 리스트
  monthlist?: Array<NonDrivingMonthModel>; // 사용내역 리스트

  focusedTab?: TabModel;

  // 검색조건
  searchQuery: string; // 검색어
  stdate: string; // 기간(시작)
  enddate: string; // 기간(끝)
  perid: string; // 담당자
  pernm: string; // 담당자명
  actcd: string; // 현장
  actnm: string; // 현장명
  divicd: string; // 부서코드
  divinm: string;
  gubun: string;

  url?: string; // 하단 url

  total: string;
  aver_tot: string;
  stopcnt_tot: string;
  stopyul_tot: string;
  mon01_tot: string;
  compmon01_tot: string;
  yul01_tot: string;
  mon02_tot: string;
  compmon02_tot: string;
  yul02_tot: string;
  mon03_tot: string;
  compmon03_tot: string;
  yul03_tot: string;
  mon04_tot: string;
  compmon04_tot: string;
  yul04_tot: string;
  mon05_tot: string;
  compmon05_tot: string;
  yul05_tot: string;
  mon06_tot: string;
  compmon06_tot: string;
  yul06_tot: string;
  mon07_tot: string;
  compmon07_tot: string;
  yul07_tot: string;
  mon08_tot: string;
  compmon08_tot: string;
  yul08_tot: string;
  mon09_tot: string;
  compmon09_tot: string;
  yul09_tot: string;
  mon10_tot: string;
  compmon10_tot: string;
  yul10_tot: string;
  mon11_tot: string;
  compmon11_tot: string;
  yul11_tot: string;
  mon12_tot: string;
  compmon12_tot: string;
  yul12_tot: string;
  montot_tot: string;
  compmontot_tot: string;
  yultot_tot: string;

  focuseddata?: NonDrivingDayModel;
}
/**
 * 컨트롤러
 * @window w_tb_e411w_03
 * @category 비운행시간현황
 */
export class NonDriving extends PageComponent<PageProps, NonDrivingState>
  implements PageToolEvents {
  tabs: Array<TabModel>;

  tabHeaders: Array<Array<GridLayoutHeader>>;

  additionalTitle: React.RefObject<GridLayoutAdditionalHeader> = React.createRef();

  grid: React.RefObject<GridLayout> = React.createRef();

  infinity?: InfinityRetrieve;

  tapChk?: number;

  mamtSum?: number; // 총 발주금액

  constructor(props: PageProps, context: any) {
    super(props, context);
    this.props.onMount && this.props.onMount(this);

    const id = NonDrivingTabId;
    const titles = NonDrivingTabTitles;

    const { user } = this.props.publicStore;
    let bosuPerid = '';
    let bosuPernm = '';
    let bosuDivicd = '';
    let bosuDivinm = '';

    this.tabs = [
      new TabModel(id.Day.toString(), MdReorder, titles[id.Day]),
      new TabModel(id.Act.toString(), MdReceipt, titles[id.Act]),
    ];

    this.tabHeaders = [
      TabHeaderDay,
      [],
    ];

    const today = new Date();

    const year = today.getFullYear(); // 년도

    let month:string | number = today.getMonth() + 1; // 월

    if (month < 10) {
      month = `0${month}`;
    }

    let date:string | number = today.getDate(); // 날짜

    if (date < 10) {
      date = `0${date}`;
    }

    if (user.kukcd !== '01') {
      bosuPerid = user.perid;
      bosuPernm = user.pernm;
      bosuDivicd = user.divicd;
      bosuDivinm = user.divinm;
    }

    // state 기본값 정의
    this.state = props.state || {
      // stdate: `${year}${month}${date}`,
      stdate: `${year - 1}${month}${date}`,
      enddate: `${year}${month}${date}`,
      dayList: [],
      monthlist: [],
      searchQuery: '', // 검색어
      perid: bosuPerid || '%', // 담당자
      pernm: bosuPernm || '', // 담당자명
      actcd: '%', // 현장
      actnm: '', // 현장명
      divicd: bosuDivicd || '%',
      divinm: bosuDivinm || '',
      gubun: '%',
      url: '',

      total: '',
      aver_tot: '',
      stopcnt_tot: '',
      stopyul_tot: '',
      mon01_tot: '',
      compmon01_tot: '',
      yul01_tot: '',
      mon02_tot: '',
      compmon02_tot: '',
      yul02_tot: '',
      mon03_tot: '',
      compmon03_tot: '',
      yul03_tot: '',
      mon04_tot: '',
      compmon04_tot: '',
      yul04_tot: '',
      mon05_tot: '',
      compmon05_tot: '',
      yul05_tot: '',
      mon06_tot: '',
      compmon06_tot: '',
      yul06_tot: '',
      mon07_tot: '',
      compmon07_tot: '',
      yul07_tot: '',
      mon08_tot: '',
      compmon08_tot: '',
      yul08_tot: '',
      mon09_tot: '',
      compmon09_tot: '',
      yul09_tot: '',
      mon10_tot: '',
      compmon10_tot: '',
      yul10_tot: '',
      mon11_tot: '',
      compmon11_tot: '',
      yul11_tot: '',
      mon12_tot: '',
      compmon12_tot: '',
      yul12_tot: '',
    };
  }

  @action
  async onFirstOpenEvent() {
    this.onTabChange(this.tabs[NonDrivingTabId.Day]);
    // await this.doRetrieve(NonDrivingTabId.Day);
  }

  @action
  async onRetrieveEvent() {
    const i = this.tabIndex;
    await this.doRetrieve(i);
  }

  @action
  async onPrintEvent() {
    const { actionStore: api } = this.props;
    const i = this.tabIndex;
    // @ts-ignore
    if (!ConfirmWarning.assert(this.state[NonDrivingTabDataStateNames[this.tabIndex]].length > 0,
      '오류', '출력할 내역이 없습니다.')) {
      return;
    }


    await api.fxPrint(
      `${NonDrivingTabFunctionNames[i]}_print`,
      {
        stdate: this.state.stdate,
        enddate: this.state.enddate,
        as_nm: this.state.searchQuery,
        perid: this.state.perid,
        divicd: this.state.divicd,
        gubun: this.state.gubun,
      },
    );
  }

  @action
  async onExcelEvent() {
    const { actionStore: api } = this.props;
    const i = this.tabIndex;
    // @ts-ignore
    if (!ConfirmWarning.assert(this.state[NonDrivingTabDataStateNames[this.tabIndex]].length > 0,
      '오류', '출력할 내역이 없습니다.')) {
      return;
    }


    await api.fxExcel(
      `${NonDrivingTabFunctionNames[i]}_excel`,
      {
        stdate: this.state.stdate,
        enddate: this.state.enddate,
        as_nm: this.state.searchQuery,
        perid: this.state.perid,
        divicd: this.state.divicd,
        gubun: this.state.gubun,
      },
    );
  }

  @computed
  get tabIndex(): NonDrivingTabId {
    return parseInt(this.state.focusedTab?.id || '0', 10);
  }

  @action
  onTabChange(focusedTab: TabModel) {
    this.setState({ focusedTab }, () => this.onRetrieveEvent());
    // eslint-disable-next-line radix
    this.tapChk = parseInt(focusedTab.id) + 1;
  }

  @action
  async doRetrieve(i: NonDrivingTabId, type: RetrieveFocusType = RetrieveFocusType.DEFAULT) {
    const { actionStore: api } = this.props;

    this.infinity = new InfinityRetrieve(
      {
        stdate: this.state.stdate,
        enddate: this.state.enddate,
        as_nm: this.state.searchQuery,
        perid: this.state.perid,
        divicd: this.state.divicd,
        gubun: this.state.gubun,
      },
      (params) => api.fxExec(
        `${NonDrivingTabFunctionNames[i]}_retrieve`,
        params,
      ),
      (items, next) => {
        if (items) {
          // @ts-ignore
          this.setState({
            [NonDrivingTabDataStateNames[i]]: [
              // @ts-ignore
              ...this.state[NonDrivingTabDataStateNames[i]],
              ...items.map((x: any) => new NonDrivingTabModels[i](x)),
            ],
          }, next);
        }
      },
      async () => {
        // @ts-ignore
        await this.SS({
          [NonDrivingTabDataStateNames[i]]: [],
        });
        await this.infinity?.retrieveAll();
        this.grid.current?.setFocus(0);
      },
    );

    // 상단 조회 버튼을 누를때는 기존 배열 초기화
    // @ts-ignore
    this.setState({
      [NonDrivingTabDataStateNames[i]]: [],
    }, async () => {
      const index = await this.infinity?.retrieveTo('id', this.state.focuseddata?.actnm, type, true) || 0;
      const data = await this.infinity?.box;
      this.setState({
        total: data?.total || '0',
        aver_tot: data?.aver_tot || '0',
        stopcnt_tot: data?.stopcnt_tot || '0',
        stopyul_tot: data?.stopyul_tot || '0',
        mon01_tot: data?.mon01_tot || '0',
        compmon01_tot: data?.compmon01_tot || '0',
        yul01_tot: data?.yul01_tot || '0',
        mon02_tot: data?.mon02_tot || '0',
        compmon02_tot: data?.compmon02_tot || '0',
        yul02_tot: data?.yul02_tot || '0',
        mon03_tot: data?.mon03_tot || '0',
        compmon03_tot: data?.compmon03_tot || '0',
        yul03_tot: data?.yul03_tot || '0',
        mon04_tot: data?.mon04_tot || '0',
        compmon04_tot: data?.compmon04_tot || '0',
        yul04_tot: data?.yul04_tot || '0',
        mon05_tot: data?.mon05_tot || '0',
        compmon05_tot: data?.compmon05_tot || '0',
        yul05_tot: data?.yul05_tot || '0',
        mon06_tot: data?.mon06_tot || '0',
        compmon06_tot: data?.compmon06_tot || '0',
        yul06_tot: data?.yul06_tot || '0',
        mon07_tot: data?.mon07_tot || '0',
        compmon07_tot: data?.compmon07_tot || '0',
        yul07_tot: data?.yul07_tot || '0',
        mon08_tot: data?.mon08_tot || '0',
        compmon08_tot: data?.compmon08_tot || '0',
        yul08_tot: data?.yul08_tot || '0',
        mon09_tot: data?.mon09_tot || '0',
        compmon09_tot: data?.compmon09_tot || '0',
        yul09_tot: data?.yul09_tot || '0',
        mon10_tot: data?.mon10_tot || '0',
        compmon10_tot: data?.compmon10_tot || '0',
        yul10_tot: data?.yul10_tot || '0',
        mon11_tot: data?.mon11_tot || '0',
        compmon11_tot: data?.compmon11_tot || '0',
        yul11_tot: data?.yul11_tot || '0',
        mon12_tot: data?.mon12_tot || '0',
        compmon12_tot: data?.compmon12_tot || '0',
        yul12_tot: data?.yul12_tot || '0',
        montot_tot: data?.montot_tot || '0',
        compmontot_tot: data?.compmontot_tot || '0',
        yultot_tot: data?.yultot_tot || '0',
      });
      this.grid.current?.setFocus(index);
      await this.onRowFocusEvent(this.state.focuseddata);
    });
  }

  @action
  onRowFocusEvent(item: any) {
    const { user } = this.props.publicStore;
    const url = `https://api.elmansoft.com/chart/stock.php?window=w_tb_e411w_03&type=0&database=${user.custcd}&as_custcd=${user.custcd}&as_spjangcd=${user.spjangcd}&as_stdate=${this.state.stdate}&as_enddate=${this.state.enddate}&as_cltcd=${this.state.gubun}&as_comp=%&as_divicd=${this.state.divicd}&as_perid=${this.state.perid}&title=비운행시간(분)`;
    // @ts-ignore
    this.setState({
      focuseddata: item,
      url,
    });
  }

  render() {
    return (
      <NonDrivingTemplate
        scope={this}
      />
    );
  }
}
